export default "__VITE_ASSET__5a5af82e__"